export default "__VITE_ASSET__BccKZyAx__"